import moment from "moment";

export const age = (v) => {
  if (!v) return null;
  return moment
    .duration(moment() - moment(v))
    .format("Y [years old]", { trunc: true });
};
